export const ROLES = {
    BOND_COUNSEL_USER: 'CSL',
    OPEN_RECORD_USER: 'ORU',
    OFFICE_OF_THE_ATTORNEY_GENERAL_USER: 'OAG',
    PUBLIC_FINANCE_USER: 'PFU',
    BOND_REVIEW_USER: 'BRB',
    MAC_USER: 'MAC',
    TX_WATER_DEV_USER: 'TWB',
    TX_EDU_AGENT_USER: 'TEA',

}

export const SYSTEM_CONSTANTS = {
    SYSTEM_NAME: 'Texas Transcript Repository',

}

export const BOND_STATUS = [
    { value: "New", label: "New" },
    { value: "Under Review", label: "Under Review" },  
    { value: "Opinion Issued", label: "Opinion Issued" },
    { value: "Registered", label: "Registered" },
    { value: "Delayed", label: "Delayed"},
    { value: "Cancelled", label: "Cancelled" },
];

export const BOND_STATUS_VALUE = {
    New: "N",
    Pending: "P",
    Cancelled: "C",
    OpinionComplete: "O",
    RegistrationComplete: "R",
    Delayed: "D",
    TranscriptComplete: "Transcript Complete"
}

export const BOND_STATUS_LABEL = {
    Cancelled: "Cancelled",
    OpinionComplete: "Opinion Issued",
    Pending: "Under Review",
    New: "New",
    Delayed: "Delayed",
    RegistrationComplete: "Registered",
    TranscriptComplete: "Transcript Complete"
}


export const USERS_TYPES = {
    BOND_COUNSEL: 'Bond Counsel',
    PARA_LEGAL: 'Paralegal ',
    OAG: 'OAG',
    LEGAL_ASSISTANT: 'Legal assistant',
    BOND_REVIEW: 'Bond Review',
    OPEN_RECORD: ' Open Record',
    PUBLIC_FINANCE: 'Public finance',
    MAC: 'Mac User',
    TWB: 'TX Water Board ',
    TEA: 'TX Education Agent '
}

export const SECURITY_TYPE = [
    { value: "", label: "Select Option" },
    { value: "B", label: "Bond" },
    { value: "C", label: "Certificate" },
    { value: "N", label: "Note" },
    { value: "T", label: "Time Warrant" },
    { value: "C_O", label: "Contractual Obligation" },
    { value: "B_1371", label: "Bond 1371" },
    { value: "N_1371", label: "Note 1371" },
    { value: "R", label: "Record of Proceedings" },
    { value: "L", label: "Lease" },
    { value: "O", label: "Other" }
];
export const INTEREST_RATE_VALUE = {
    FIXED_INTEREST: 'F',
    VARIABLE_INTEREST: 'V',
}



export const INTEREST_TYPE = [
    { value: "", label: "Select Option" },
    { value: "V", label: "Variable" },
    { value: "F", label: "Fixed" },

];
export const ROLE_USER_TYPE_MAP = {
    [ROLES.BOND_COUNSEL_USER]: USERS_TYPES.BOND_COUNSEL,
    [ROLES.OPEN_RECORD_USER]: USERS_TYPES.OPEN_RECORD, // Mapped to a new user type
    [ROLES.OFFICE_OF_THE_ATTORNEY_GENERAL_USER]: USERS_TYPES.OAG,
    [ROLES.PUBLIC_FINANCE_USER]: USERS_TYPES.PUBLIC_FINANCE, // Mapped to a new user type
    [ROLES.BOND_REVIEW_USER]: USERS_TYPES.BOND_REVIEW,
    [ROLES.MAC_USER]: USERS_TYPES.MAC, // Ensure 'MAC' exists in USERS_TYPES
    [ROLES.TX_WATER_DEV_USER]: USERS_TYPES.TWB,
    [ROLES.TX_EDU_AGENT_USER]: USERS_TYPES.TEA,
};

export const USER_TYPE_ROLE_MAP = {
    [USERS_TYPES.BOND_COUNSEL]: ROLES.BOND_COUNSEL_USER,
    [USERS_TYPES.OPEN_RECORD]: ROLES.OPEN_RECORD_USER,
    [USERS_TYPES.OAG]: ROLES.OFFICE_OF_THE_ATTORNEY_GENERAL_USER,
    [USERS_TYPES.PUBLIC_FINANCE]: ROLES.PUBLIC_FINANCE_USER,
    [USERS_TYPES.BOND_REVIEW]: ROLES.BOND_REVIEW_USER,
    [USERS_TYPES.MAC]: ROLES.MAC_USER,
    [USERS_TYPES.PARA_LEGAL]: ROLES.BOND_COUNSEL_USER,
    [USERS_TYPES.LEGAL_ASSISTANT]: ROLES.OFFICE_OF_THE_ATTORNEY_GENERAL_USER,
    [USERS_TYPES.TWB]: ROLES.TX_WATER_DEV_USER,
    [USERS_TYPES.TEA]: ROLES.TX_EDU_AGENT_USER,
};


export function getUserTypeByRole(roleCode) {
    return ROLE_USER_TYPE_MAP[roleCode] || '';
}

export function getRoleByUserType(userType) {
    return USER_TYPE_ROLE_MAP[userType] || '';
}

export const BOND_ACTION = {
    DELETE: 'delete',
    UPLOAD: 'upload',
}